import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WaitingBallComponent } from './waiting-ball.component';

@NgModule({
  declarations: [
    WaitingBallComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WaitingBallComponent
  ]
})
export class WaitingBallModule { }
